/** First following element sibling with non-zero layout height (skips e.g. empty overlay section groups). */
const nextElementSiblingWithLayoutHeight = (start) => {
  for (let el = start?.nextElementSibling; el; el = el.nextElementSibling) {
    if (el.offsetHeight > 0) return el;
  }
  return null;
}

const initHeader = () => {
  const header = document.querySelector('.sc-updated--header');
  const bottomMenu = document.querySelector('.sc-updated-header__bottom');
  const shopButton = document.querySelector('.updated-mega-menu__shop-button');
  const parentLinksUl = bottomMenu?.querySelector('.mega-menu__parent-links');
  const menuOverlay = document.querySelector('.popup-overlay[data-sc-menu-overlay]');
  const submenus = document.querySelector('.sc-updated-header__submenus');
  const submenusBottomHeight = getComputedStyle(submenus).height;
  const headerHeight = getComputedStyle(header).height;
  const announcementBarHeightValue = parseFloat(getComputedStyle(document.querySelector('.announcement-bar')).height) || 40;
  document.documentElement.style.setProperty('--submenu-bottom-height', `${submenusBottomHeight}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  const shouldDynamicallyPad = document.querySelector('header').hasAttribute('data-dynamically-pad');
  const outerSectionId = document.querySelector('header')?.dataset?.outerSectionId;
  const outerSection = document.querySelector(`#${outerSectionId}`);

  if (shouldDynamicallyPad){
    const submenusHeightValue = parseFloat(getComputedStyle(submenus).height);
    const nextSibling = nextElementSiblingWithLayoutHeight(outerSection);
    let paddingTop = submenusHeightValue ? submenusHeightValue : 0;
    if(document.documentElement.style.getPropertyValue('--header-height')){
      const headerHeightValue = parseFloat(document.documentElement.style.getPropertyValue('--header-height'));
      paddingTop += headerHeightValue;
    } 
    if(nextSibling){
      nextSibling.style.paddingTop = `${paddingTop}px`;
    }
  }

  window.addEventListener('scroll', () => {
    if (window.scrollY > announcementBarHeightValue) {
      submenus.classList.add('scroll-down-hide');
    } else {
      submenus.classList.remove('scroll-down-hide');
    }
  });
  document.addEventListener('keydown', () => {
    header?.classList.remove('sc-header-focus-from-pointer');
    document.querySelector('.sc-updated-header__submenus')?.classList.remove('sc-header-focus-from-pointer');
  });

  /* Add pointer class in capture phase so it's set before focus moves on mousedown */
  document.addEventListener('mousedown', (e) => {
    if (header?.contains(e.target)) header.classList.add('sc-header-focus-from-pointer');
    const submenus = document.querySelector('.sc-updated-header__submenus');
    if (submenus?.contains(e.target)) submenus.classList.add('sc-header-focus-from-pointer');
  }, true);

  if (bottomMenu && shopButton) {
    const allPanels = () => bottomMenu.querySelectorAll('.child-links__wrapper');
    const parentLinks = bottomMenu.querySelectorAll('.mega-menu__parent-link__wrapper');

  function resetToFirstPanel() {
    allPanels().forEach((panel) => panel.classList.add('hidden'));
    const first = bottomMenu.querySelector('.child-links__wrapper');
    if (first) first.classList.remove('hidden');
    parentLinks.forEach((link) => link.classList.remove('is-active'));
  }


  /** Set the parent links <ul> width so its right edge aligns with the shop button (same row in top bar). Rect deltas are in viewport (post-zoom) pixels when html uses CSS zoom (theme magnification); layout width must be divided by that zoom so the column matches visually. */
  function syncParentLinksWidth() {
    if (!parentLinksUl) return;
    const shopRect = shopButton.getBoundingClientRect();
    const container = parentLinksUl.parentElement;
    if (!container) return;
    const containerRect = container.getBoundingClientRect();
    const htmlZoomRaw = parseFloat(getComputedStyle(document.documentElement).zoom);
    const htmlZoom =
      Number.isFinite(htmlZoomRaw) && htmlZoomRaw > 0 ? htmlZoomRaw : 1;
    let widthPx = (shopRect.left - containerRect.left) / htmlZoom;

    widthPx = Math.max(0, widthPx);
    parentLinksUl.style.width = `${widthPx}px`;
    parentLinksUl.style.flex = `0 0 ${widthPx}px`;
  }

  let mainMenuEscapeHandler = null;

  function setMenuOpen(isOpen, openedByEnter = false) {
    bottomMenu.classList.toggle('is--visible', isOpen);
    shopButton.setAttribute('aria-expanded', isOpen);
    document.body.classList.toggle('no-scroll', isOpen);
    document.body.classList.toggle('sc-menu-open', isOpen);
    if (menuOverlay) menuOverlay.setAttribute('aria-hidden', !isOpen);
    if (isOpen) {
      bottomMenu.removeAttribute('inert');
      shopButton.blur();
      if (openedByEnter && typeof getFocusableElements === 'function' && typeof trapFocus === 'function') {
        const focusable = getFocusableElements(bottomMenu);
        if (focusable && focusable.length > 0) trapFocus(bottomMenu, focusable[0]);
      }
      mainMenuEscapeHandler = (e) => {
        if (e.code !== 'Escape') return;
        if (!bottomMenu.classList.contains('is--visible')) return;
        const visiblePanel = bottomMenu.querySelector('.child-links__wrapper:not(.hidden)');
        if (visiblePanel && visiblePanel.contains(document.activeElement)) return;
        setMenuOpen(false);
        document.removeEventListener('keydown', mainMenuEscapeHandler);
        mainMenuEscapeHandler = null;
      };
      document.addEventListener('keydown', mainMenuEscapeHandler);
    } else {
      bottomMenu.setAttribute('inert', '');
      if (mainMenuEscapeHandler) {
        document.removeEventListener('keydown', mainMenuEscapeHandler);
        mainMenuEscapeHandler = null;
      }
      if (typeof removeTrapFocus === 'function') removeTrapFocus(shopButton);
      resetToFirstPanel();
    }
  }

  if (!bottomMenu.classList.contains('is--visible')) bottomMenu.setAttribute('inert', '');

  /* Run once after layout so parent links width is set before the menu is ever opened (avoids jump). */
  requestAnimationFrame(() => syncParentLinksWidth());

  window.addEventListener('resize', () => syncParentLinksWidth());

  shopButton.addEventListener('click', () => {
    const isOpen = !bottomMenu.classList.contains('is--visible');
    setMenuOpen(isOpen, false);
  });
  shopButton.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const isOpen = !bottomMenu.classList.contains('is--visible');
    setMenuOpen(isOpen, isOpen);
  });

  if (menuOverlay) {
    menuOverlay.addEventListener('click', () => {
      if (bottomMenu.classList.contains('is--visible')) setMenuOpen(false);
    });
  }

  function activateParentLink(link) {
    link.classList.add('is-active');
    if (link.dataset.hasChildren && link.dataset.linkId) {
      allPanels().forEach((panel) => panel.classList.add('hidden'));
      const panel = bottomMenu.querySelector(`.child-links__wrapper[data-parent-link-id="${link.dataset.linkId}"]`);
      if (panel) panel.classList.remove('hidden');
    }
  }

  let panelEscapeHandler = null;

  parentLinks.forEach((link) => {
    link.addEventListener('mouseenter', () => activateParentLink(link));
    link.addEventListener('mouseleave', () => {
      link.classList.remove('is-active');
    });
    link.addEventListener('focusin', () => activateParentLink(link));
    link.addEventListener('focusout', (e) => {
      const next = e.relatedTarget;
      const panel = link.dataset.linkId
        ? bottomMenu.querySelector(`.child-links__wrapper[data-parent-link-id="${link.dataset.linkId}"]`)
        : null;
      if (panel && next && panel.contains(next)) return;
      link.classList.remove('is-active');
    });

    link.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (!link.dataset.hasChildren || !link.dataset.linkId) return;
      const panel = bottomMenu.querySelector(`.child-links__wrapper[data-parent-link-id="${link.dataset.linkId}"]`);
      if (!panel) return;
      e.preventDefault();
      const focusable = typeof getFocusableElements === 'function' && getFocusableElements(panel);
      if (!focusable || focusable.length === 0) return;
      activateParentLink(link);
      if (typeof trapFocus === 'function') trapFocus(panel, focusable[0]);
      if (panelEscapeHandler) document.removeEventListener('keydown', panelEscapeHandler);
      const parentLinkFocusable = link.querySelector('.parent-link') || (typeof getFocusableElements === 'function' && getFocusableElements(link))?.[0];
      panelEscapeHandler = (ev) => {
        if (ev.key !== 'Escape') return;
        if (typeof removeTrapFocus === 'function') removeTrapFocus(parentLinkFocusable || link);
        document.removeEventListener('keydown', panelEscapeHandler);
        panelEscapeHandler = null;
      };
      document.addEventListener('keydown', panelEscapeHandler);
    });
  });
  }

  // Submenu panels (sc-updated-submenu): click/mousedown on list-menu--megamenu toggles panel (replaces hover)
  const submenusContainer = document.querySelector('.sc-updated-header__submenus');
  if (submenusContainer) {
    const megaMenuItems = submenusContainer.querySelectorAll('.list-menu--megamenu');
    const visibleClass = 'list-menu--megamenu-visible';
    let openSubmenuTrigger = null;
    let submenuEscapeHandler = null;

    function closeAllSubmenuPanels(toFocus = null) {
      const trigger = toFocus || openSubmenuTrigger;
      megaMenuItems.forEach((li) => {
        li.classList.remove(visibleClass);
        const t = li.firstElementChild;
        if (t && t.classList.contains('header__menu-item')) {
          t.setAttribute('aria-expanded', 'false');
        }
      });
      openSubmenuTrigger = null;
      if (submenuEscapeHandler) {
        document.removeEventListener('keydown', submenuEscapeHandler);
        submenuEscapeHandler = null;
      }
      if (trigger && typeof removeTrapFocus === 'function') removeTrapFocus(trigger);
    }

    megaMenuItems.forEach((li) => {
      const panel = li.querySelector('.sc-updated-header__submenu');
      const trigger = li.firstElementChild;
      if (!trigger || !panel || !trigger.classList.contains('header__menu-item')) return;

      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('role', 'button');

      const openPanel = (e) => {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        const wasOpen = li.classList.contains(visibleClass);
        if (e && wasOpen) submenusContainer.classList.add('sc-header-focus-from-pointer');
        closeAllSubmenuPanels();
        if (!wasOpen) {
          li.classList.add(visibleClass);
          trigger.setAttribute('aria-expanded', 'true');
          openSubmenuTrigger = trigger;
          const openedByEnter = e && e.key === 'Enter';
          if (openedByEnter && typeof getFocusableElements === 'function' && typeof trapFocus === 'function') {
            const focusable = getFocusableElements(panel);
            if (focusable && focusable.length > 0) trapFocus(panel, focusable[0]);
          } else {
            trigger.blur();
          }
          submenuEscapeHandler = (ev) => {
            if (ev.code !== 'Escape') return;
            const visibleLi = submenusContainer.querySelector('.list-menu--megamenu-visible');
            if (!visibleLi) return;
            closeAllSubmenuPanels(visibleLi.firstElementChild);
          };
          document.addEventListener('keydown', submenuEscapeHandler);
        }
      };

      trigger.addEventListener('mousedown', openPanel);
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          openPanel(e);
        }
      });
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    document.addEventListener('click', (e) => {
      if (!submenusContainer.contains(e.target)) {
        header?.classList.add('sc-header-focus-from-pointer');
        submenusContainer.classList.add('sc-header-focus-from-pointer');
        closeAllSubmenuPanels();
      }
    });
  }

  const subMenus = document.querySelectorAll('.sc-updated-header__submenu');
  subMenus.forEach((submenu) => {
    submenu.querySelectorAll('.grandchild-links:not(.is-expanded)').forEach((ul) => {
      ul.setAttribute('inert', '');
    });
    const subMenuChildLinks = submenu.querySelectorAll('.submenu__child-link');
    subMenuChildLinks.forEach((childLink) => {
      const expandGrandChildButton = childLink.querySelector('.expand-grandchild');
      if (expandGrandChildButton) {
        expandGrandChildButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          childLink.classList.toggle('is-expanded');
          const grandChildLinks = childLink.querySelectorAll('.grandchild-links');
          grandChildLinks.forEach((grandChildLink) => {
            grandChildLink.classList.toggle('is-expanded');
            if (grandChildLink.classList.contains('is-expanded')) {
              grandChildLink.removeAttribute('inert');
            } else {
              grandChildLink.setAttribute('inert', '');
            }
          });
          const isExpanded = childLink.classList.contains('is-expanded');
          expandGrandChildButton.setAttribute('aria-expanded', isExpanded);
        });
      }
    });
  });
}
const initLinkIconImages = async () => {
  const linkIconTemplateHandle = document.querySelector('[data-link-icon-template-handle]')?.dataset?.linkIconTemplateHandle;
  if (!linkIconTemplateHandle) return;
  const linkIconImages = await fetch(`/pages/${linkIconTemplateHandle}?view=link-images`);
  const linkIconImagesData = await linkIconImages.json();
  if (linkIconImagesData.length > 0) {
    linkIconImagesData.forEach((linkIconImage) => {
      const linkIconPlaceholders = document.querySelectorAll(`[data-link-handle="${linkIconImage.linkHandle}"]`);
      linkIconPlaceholders.forEach((placeholder) => {
        const imageClass = placeholder?.dataset?.imageClass;
        if (placeholder) {
          const img = document.createElement('img');
          img.src = linkIconImage.linkIconUrl;
          img.alt = linkIconImage.linkTitle;
          if (imageClass) img.className = imageClass;
          placeholder.replaceWith(img);
        }
      })
      
    });
    const remainingPlaceholders = document.querySelectorAll('link-icon-placeholder');
    if(remainingPlaceholders.length > 0) {
      remainingPlaceholders.forEach((placeholder) => {
        placeholder.classList.add(placeholder?.dataset?.imageClass);
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initLinkIconImages();
});
document.addEventListener('shopify:section:load', () => {
  initHeader();
  initLinkIconImages();
});